import {
  DELETE_IMPORT_SKIP_OVERWRITE_LIST_ITEMS,
  MERGE_LIST_ITEMS,
  MERGE_OVERWRITE_LIST_ITEMS,
  OVERWRITE_LIST_ITEMS,
  SKIP_OVERWRITE_LIST_ITEMS,
} from '../constants/common.constants';

export const getActionMenuItems = ({ type }) => {
  switch (true) {
    case MERGE_LIST_ITEMS.includes(type):
      return [{ value: 'Merge', label: 'Merge' }];
    case MERGE_OVERWRITE_LIST_ITEMS.includes(type):
      return [
        { value: 'Overwrite', label: 'Overwrite' },
        { value: 'Merge', label: 'Merge' },
      ];
    case OVERWRITE_LIST_ITEMS.includes(type):
      return [{ value: 'Overwrite', label: 'Overwrite' }];
    case DELETE_IMPORT_SKIP_OVERWRITE_LIST_ITEMS.includes(type):
      return [
        { value: 'DeleteAndImport', label: 'DeleteAndImport' },
        { value: 'Overwrite', label: 'Overwrite' },
        { value: 'Skip', label: 'Skip' },
      ];
    case SKIP_OVERWRITE_LIST_ITEMS.includes(type):
      return [
        { value: 'Overwrite', label: 'Overwrite' },
        { value: 'Skip', label: 'Skip' },
      ];
    default:
      return [
        { value: 'Overwrite', label: 'Overwrite' },
        { value: 'Skip', label: 'Skip' },
      ];
  }
};
